/*@ngInject*/
const UIDraggableComponentButtonDirective = function ($rootScope, $timeout, fieldType, formMediator, formViewerConstant) {

    var linkFunction = function ($scope, $elm, $attr) {

        var element = $($elm),
            componentFieldTemplate,
            sectionFieldTemplate,
            rowRepeaterFieldTemplate,
            isSection,
            isRowRepeater;

        element.attr('draggable', 'true');

        function init() {
            var formTemplateType = $scope.paletteButton.formTemplateType;

            isSection = $scope.paletteButton.type === -1;
            isRowRepeater = $scope.paletteButton.type === fieldType.ROWREPEATER;

            if (isSection) {
                getSectionFieldTemplate(formTemplateType);
            }
            else if (isRowRepeater) {
                getRowRepeaterFieldTemplate(formTemplateType);
            }
            else {
                getComponentFieldTemplate(formTemplateType);
            }
        }

        function onDragStart(event) {
            var dataTransfer = event.originalEvent.dataTransfer,
                dragConfiguration;

            if (isSection) {
                dragConfiguration = buildSectionDragConfiguration();
            }
            else if (isRowRepeater) {
                dragConfiguration = buildRowRepeaterDragConfiguration();
            }
            else {
                dragConfiguration = buildComponentDragConfiguration();
            }

            element.addClass('dragging');
            dataTransfer.effectAllowed = 'move';
            event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
            formMediator.setCurrentDragItem(dragConfiguration);
        }

        function buildComponentDragConfiguration() {
            var dragConfiguration;

            dragConfiguration = {
                dragType: formViewerConstant.configuration.dragOperationType.INSERT,
                formStructureType: formViewerConstant.configuration.formStructureType.COMPONENT,
                componentType: $scope.paletteButton.type,
                uiField: componentFieldTemplate
            };

            return dragConfiguration;
        }

        function buildSectionDragConfiguration() {
            var dragConfiguration,
                newSectionFieldTemplate = _.cloneDeep(sectionFieldTemplate);

            dragConfiguration = {
                dragType: formViewerConstant.configuration.dragOperationType.INSERT,
                formStructureType: formViewerConstant.configuration.formStructureType.SECTION,
                uiSection: newSectionFieldTemplate
            };

            return dragConfiguration;
        }

        function buildRowRepeaterDragConfiguration() {
            var dragConfiguration,
                newRowRepeaterFieldTemplate = _.cloneDeep(rowRepeaterFieldTemplate);

            dragConfiguration = {
                dragType: formViewerConstant.configuration.dragOperationType.INSERT,
                formStructureType: formViewerConstant.configuration.formStructureType.ROW_REPEATER,
                uiRow: newRowRepeaterFieldTemplate
            };

            return dragConfiguration;
        }

        function getComponentFieldTemplate(formTemplateType) {
            formMediator.getUiFieldByType($scope.paletteButton.type, formTemplateType).then(function (uiField) {
                componentFieldTemplate = uiField;
            });
        }

        function getSectionFieldTemplate(formTemplateType) {
            formMediator.buildEmptySectionTemplate(formTemplateType).then(function (uiSection) {
                sectionFieldTemplate = uiSection;
            });
        }

        function getRowRepeaterFieldTemplate(formTemplateType) {
            formMediator.buildRowRepeaterTemplate(formTemplateType).then(function (uiRow) {
                rowRepeaterFieldTemplate = uiRow;
            });
        }

        function onDragEnd() {
            element.removeClass('dragging');
            init();
        }

        element.on('dragstart', onDragStart);
        element.on('dragend', onDragEnd);

        $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'false');
        });

        $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'true');
        });

        $scope.$on('$destroy', function () {
            element.off('dragstart', onDragStart);
            element.off('dragend', onDragEnd);
        });

        init();
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('ums.configuration')
    .directive('uiDraggableComponentButton', UIDraggableComponentButtonDirective);
